import { PAGES } from 'data/page-data';

const config = [
    ...PAGES.map((page) => {
        return {
            path: page.path,
            page: page.name,
        };
    }),

    {
        path: '/sandbox(/)(*)',
        page: 'sandbox',
        disabled: __ENV__ !== 'local' && __ENV__ !== 'development',
    },

    {
        path: '*',
        page: '404',
        options: {
            deeplink: false,
        },
    },
];

export const routes = config.filter((route) => !route.disabled);
